<template>
  <div class="m-hcity">
    <dl>
      <dt>{{ title }}</dt>
      <dd v-for="(item, index) in list" :key="index" @click="changeCity(item)">
        {{ item }}
      </dd>
    </dl>
  </div>
</template>
<script>
// import api from "@/api/index.js";
export default {
  props: ["title", "list"],
  methods: {
    changeCity(item) {
      //字母详情城市点击跳转
      this.$store.dispatch("setPosition", { name: item });
      this.$router.push({ name: "index" });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/changecity/hot.scss";
</style>
